const boardView = (projectId, page) => `projects/${projectId}/${page}/board_view`;
export default {
  boardView
};
